import { resolveStaffModuleAccess } from './staffModulePermissions';

export const HABERES_VARIABLES_MODULE_ID = 'haberes_variables';

function isCompanyHaberesVariablesGranted(companyPerms) {
  if (companyPerms === undefined) return false;
  const row = (companyPerms || []).find((p) => p.moduleId === HABERES_VARIABLES_MODULE_ID);
  return row?.hasAccess === true;
}

export function resolveHaberesVariablesAccess(
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
) {
  if (!isCompanyHaberesVariablesGranted(companyPerms)) return false;
  return resolveStaffModuleAccess(
    HABERES_VARIABLES_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}
